export class State {
  text: string = "";
  theme: string = "info";
  active: boolean = false;
  onChange: any = null;
  // TODO move loading out of snackbar or rename snackbar to fit the logick
  loading: boolean = false;
}
